// extracted by mini-css-extract-plugin
export default {"pin":"Marker_pin__W0kov","tooltip":"Marker_tooltip__X7UA+","description":"Marker_description__BQaRy"};